import {
    DotsVerticalIcon,
    XIcon,
} from '../../Icon'
import {
    Dropdown,
    DropdownButtonNew as DropdownButton,
    DropdownContent,
} from '../../Dropdown'
import {
    styledActionContainer,
    styledActions,
} from '../styles/Menubar'
import Button from '../../Button'
import {DialogueMenubarViewProps} from './types'
import MenubarName from '../MenubarName'
import React from 'react'
import {styled} from '../../../stitches/config'
import {styledItem} from 'components/Dropdown/styles'
import {useTranslation} from 'react-i18next'

const StyledActionContainer = styled('div', styledActionContainer)
const StyledActions = styled('div', styledActions)
const StyledItem = styled('div', styledItem)

const DialogueMenubarView = (props: DialogueMenubarViewProps): React.ReactElement => {
    const {
        chat,
        isChannelSidebarOpen,
        onHide,
        onToggleChannelSidebar,
    } = props

    const {t} = useTranslation()

    return (
        <>
            <MenubarName
                chat={chat}
                isChannelSidebarOpen={isChannelSidebarOpen}
                onToggleChannelSidebar={onToggleChannelSidebar}
            />
            <StyledActionContainer>
                <StyledActions>
                    <Dropdown>
                        <DropdownButton caret={false} color='text' iconRight={DotsVerticalIcon} />
                        <DropdownContent direction='fixed-end'>
                            <StyledItem>
                                <Button
                                    color='text'
                                    iconLeft={XIcon}
                                    onPress={() => { onHide(chat.user_id || '') }}
                                    text={t('Hide conversation')}
                                    title={t('Hide conversation')}
                                />
                            </StyledItem>
                        </DropdownContent>
                    </Dropdown>
                </StyledActions>
            </StyledActionContainer>
        </>
    )
}

export default DialogueMenubarView
